// extracted by mini-css-extract-plugin
export default {"menuBlock":"BE-z","title":"CE-z","nav":"DE-z","flexCell":"EE-z","facetLink":"FE-z"};